/**
 * Canonical URLs for chart UI, CTAs, and printable report footers.
 * Used by /chart, /chart/report, /chart/report/print — keep in sync with marketing site.
 */
export const AMM_MAIN_SITE = 'https://www.astralmoonmagic.com';
export const AMM_ASTROLOGY_BLUEPRINT_COURSE = `${AMM_MAIN_SITE}/astrology-blueprint-course`;
export const AMM_PRACTICE_LAB = `${AMM_MAIN_SITE}/practice-lab`;
/** Big Three tool is hosted on the same origin as the chart app (e.g. astro.astralmoonmagic.com). */
export const BIG_THREE_CHECKER_PATH = '/big-three-checker/';
